import scheduler from "@homer.core/scheduler";
import Script from "@homer.core/script";
import createHash from "@homer.utility/hash";
import homer from "@homer.api/homer";
import StorageLocal from "@homer.core/storage.local";
import unifold from "@unifold/core";
import { name } from "../package.json";

const defaultDeviceIdentifier = {
    vendor: null,
    manufacturer: null,
    model: null,
    name: null,
};
const defaultState = JSON.stringify({
    hash: null,
    identifier: defaultDeviceIdentifier,
});

const migrate = (current) => {
    if (current?.device) {
        current.identifier = current.device;

        delete current.device;
    }

    // Keep missing or legacy device state aligned with the API and middleware default shape.
    if (!current?.identifier || typeof current.identifier !== "object") {
        current.identifier = { ...defaultDeviceIdentifier };
    }

    return current;
};

const client = new homer.Client("/api");
const storageLocal = new StorageLocal(name, {
    version: "1.0.0", // set manually here to be able to invalidate for incompatible changes
    lifetime: 24 * 60 * 60,
});
const parseState = () => {
    try {
        const state = JSON.parse(storageLocal.get() || defaultState);

        return state && typeof state === "object" ? state : JSON.parse(defaultState);
    } catch {
        return JSON.parse(defaultState);
    }
};
const current = migrate(parseState());

storageLocal.on("change", () => {
    Object.assign(current, migrate(parseState()));
});

if (!current.hash) {
    void scheduler.yield.low().then(() => {
        const ready = new Promise((resolve) => {
            globalThis.DeviceAtlas = {
                cacheType: "none",
                onPropertiesUpdate: (_, capabilities) => {
                    resolve(capabilities);
                },
            };
        });

        new Script("/proxy/device", {
            id: "device",
            resolver: (resolve) => {
                ready.then(resolve);
            },
        })
            .then((capabilities) => {
                const hash = createHash(capabilities);

                if (current.hash === hash) {
                    return;
                }

                client
                    .post(
                        "/device/retrieve",
                        { capabilities },
                        homer.Request.flag.attachClienthints |
                            homer.Request.flag.prioritize |
                            homer.Request.flag.suppressEvents,
                    )
                    .then((identifier) => {
                        current.hash = hash;
                        current.identifier = identifier;

                        storageLocal.set(JSON.stringify(current));
                    })
                    .catch(() => {
                        queueMicrotask(() => {
                            throw new globalThis.CustomError("external", {
                                text: `[${name}] Could not load /api/device/retrieve`,
                            });
                        });
                    })
                    .finally(() => {
                        new unifold.Event("device/retrieved", {
                            hash: current.hash,
                            device_identifier: current.identifier,
                        }).dispatch();
                    });
            })
            .catch(() => {
                queueMicrotask(() => {
                    throw new globalThis.CustomError("external", {
                        text: `[${name}] Could not load /proxy/device`,
                    });
                });
            });
    });
}

export default scheduler.yield.low().then(() => current);
